import React, { useState } from "react";
import clsx from "clsx";
import {
  Grid,
  Typography,
  Button,
  Hidden,
  TextField,
  FormGroup,
  FormControlLabel,
  Checkbox,
  FormControl,
  InputAdornment,
  InputLabel,
  OutlinedInput,
  IconButton,
} from "@material-ui/core";
import Visibility from "@material-ui/icons/Visibility";
import VisibilityOff from "@material-ui/icons/VisibilityOff";
import { makeStyles } from "@material-ui/core/styles";
import LoginImage from "../../resources/LoginImage.png";
import LoginBtnIcon from "../../resources/LoginBtnIcon.png";

const useStyles = makeStyles((theme) => ({
  root: {},
  Login_first: {
    backgroundImage: `url(${LoginImage})`,
    backgroundRepeat: "no-repeat",
    backgroundSize: "cover",
    backgroundPosition: "center center",
    height: "1080px",
  },
  Login_second: {
    height: "1080px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  Login_second_section: {
    "& h2": {
      fontFamily: "Rubik",
      fontStyle: "normal",
      fontWeight: "500",
      fontSize: "50px",
      color: "#414042",
      width: "134px",
      marginBottom: "54px",
      "& span": {
        color: "#F53838",
      },
    },
    "& button": {
      width: "546px",
      height: "84px",
      background: "#F53838",
      boxShadow: "0px 4px 4px rgba(0, 0, 0, 0.1)",
      width: "546px",
      height: "84px",
      background: "#FFFFFF",
      boxShadow: "0px 4px 4px rgba(0, 0, 0, 0.1)",
      fontFamily: "Rubik",
      textTransform: "none",
      fontStyle: "normal",
      fontWeight: "500",
      fontSize: "25px",
      lineHeight: "30px",
      color: "#696969",
      marginBottom: "32px",

      "& span": {
        display: "flex",
        alignItems: "center",
        justifyContent: "space-evenly",
      },
    },
    "& button:hover": {
      background: "#F8F8FF",
    },
  },
  Login_second_section_divider: {
    display: "flex",
    alignItems: "center",
    marginBottom: "32px",

    "& span": {
      display: "inline-block",
      height: "1px",
      background: "#FF8179",
      width: "133px",
    },
    "& h6": {
      margin: "0px 34px",
      fontFamily: "Rubik",
      fontStyle: "normal",
      fontWeight: "500",
      fontSize: "25px",
      lineHeight: "30px",
      color: "#F53838",
    },
  },

  input_100: {
    width: "100%",
    marginBottom: "16px",
    "& .MuiInputBase-input": {
      border: "1px solid #CECECE",
      fontFamily: "Rubik",
      fontStyle: "normal",
      fontWeight: "normal",
      fontSize: "21px",
      lineHeight: "25px",
      color: " #595959",
    },
  },
  input_check: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    "& .MuiTypography-body1": {
      fontFamily: "Rubik",
      fontStyle: "normal",
      fontWeight: "300",
      fontSize: "16px",
    },
    "& .MuiTypography-h6": {
      fontFamily: "Rubik",
      fontStyle: "normal",
      fontWeight: "normal",
      fontSize: "17px",
    },
  },

  input_btn: {
    "& button": {
      width: "546px",
      height: "84px",
      background: "#F53838",
      boxShadow: "0px 4px 4px rgba(0, 0, 0, 0.1)",
      width: "546px",
      height: "66px",
      boxShadow: "0px 4px 4px rgba(0, 0, 0, 0.1)",
      fontFamily: "Rubik",
      textTransform: "none",
      fontStyle: "normal",
      fontWeight: "500",
      fontSize: "25px",
      lineHeight: "30px",
      color: "#fff",
      borderRadius: "0px",
      marginTop: "26px",
      "&:hover": {
        background: "#F83030",
      },
    },
  },

  [theme.breakpoints.down("xs")]: {
    input_btn: {
      "& button": {
        width: "100%",
      },
    },
    Login_second_section: {
      "& button": {
        width: "100%",
      },
    },
  },
  [theme.breakpoints.down("sm")]: {
    Login_second: {
      height: "100vh",
    },
  },
  [theme.breakpoints.only("md")]: {
    Login_second_section: {
      width: "100%",
    },
    input_btn: {
      "& button": {
        width: "100%",
      },
    },
    Login_second_section: {
      "& button": {
        width: "100%",
      },
    },
  },
}));

function Login() {
  const classes = useStyles();

  const [values, setValues] = React.useState({
    amount: "",
    password: "",
    weight: "",
    weightRange: "",
    showPassword: false,
  });

  const handleChange = (prop) => (event) => {
    setValues({ ...values, [prop]: event.target.value });
  };

  const handleClickShowPassword = () => {
    setValues({ ...values, showPassword: !values.showPassword });
  };

  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };

  return (
    <div>
      <Grid container>
        <Hidden smDown>
          <Grid item sm={12} md={6} className={classes.Login_first}></Grid>
        </Hidden>
        <Grid item xs={12} sm={12} md={6} className={classes.Login_second}>
          <Grid
            container
            direction="column"
            alignItems="center"
            className={classes.Login_second_section}
          >
            <Grid item className={classes.one} xs={12}>
              <Typography variant="h2">
                Log<span>in</span>
              </Typography>
            </Grid>

            <Grid item xs={12}>
              <Button
                variant="contained"
                color="primary"
                edge="end"
                startIcon={<img src={LoginBtnIcon} />}
              >
                Continue with Google
              </Button>
            </Grid>

            <Grid item className={classes.Login_second_section_divider} xs={12}>
              <span></span>
              <Typography variant="subtitle1">OR</Typography>
              <span></span>
            </Grid>
            <Grid item xs={12}>
              <form className={classes.root} noValidate autoComplete="off">
                <div>
                  <FormControl className={classes.input_100}>
                    <TextField
                      id="email"
                      label="Email*"
                      variant="outlined"
                      color="secondary"
                    />
                  </FormControl>
                </div>
                <div>
                  <FormControl className={classes.input_100}>
                    <TextField
                      id="password"
                      label="Password*"
                      variant="outlined"
                      color="secondary"
                    />
                  </FormControl>
                </div>
                <div className={classes.input_check}>
                  <FormGroup>
                    <FormControlLabel
                      control={<Checkbox name="gilad" />}
                      label="Stay Connected"
                    />
                  </FormGroup>
                  <Typography variant="h6">Forgot your password?</Typography>
                </div>
                <div className={classes.input_btn}>
                  <Button variant="contained" color="primary">
                    Login
                  </Button>
                </div>
              </form>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </div>
  );
}

export default Login;
